<template>
  <div>
    <fieldset id="rating_stars" class="c-sitter-rating o-rating" name="stars">
      <legend class="h3 c-rating__question">How was your experience working with {{ sitterFirstName }}?</legend>
      <div class="o-star__container c-stars__wrapper">
        <star :selected-callback="ratingSelected" :score="5" value="FIVE_STARS" />
        <label class="o-star__label c-sitter__stars" for="star5">5 stars</label>

        <star :selected-callback="ratingSelected" :score="4" value="FOUR_STARS" />
        <label class="o-star__label c-sitter__stars" for="star4">4 stars</label>

        <star :selected-callback="ratingSelected" :score="3" value="THREE_STARS" />
        <label class="o-star__label c-sitter__stars" for="star3">3 stars</label>

        <star :selected-callback="ratingSelected" :score="2" value="TWO_STARS" />
        <label class="o-star__label c-sitter__stars" for="star2">2 stars</label>

        <star :selected-callback="ratingSelected" :score="1" value="ONE_STAR" />
        <label class="o-star__label c-sitter__stars" for="star1">1 star</label>
      </div>
    </fieldset>

    <div class="c-rating__score">
      <p class="c-score__title">{{ scoreTitle }}</p>
      <p class="c-score__description">{{ scoreDescription }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import Star from '../Star.vue';

const titles = {
  FIVE_STARS: 'Great',
  FOUR_STARS: 'Okay',
  THREE_STARS: 'Meh',
  TWO_STARS: 'Bad',
  ONE_STAR: 'Terrible',
};

const descriptions = {
  FIVE_STARS: 'Would use again',
  FOUR_STARS: 'Got the job done',
  THREE_STARS: 'Not the right fit',
  TWO_STARS: 'Would not recommend',
  ONE_STAR: 'Had serious issues',
};

export default {
  name: 'StarRatingReview',
  components: {
    Star,
  },
  props: {
    sitterFirstName: {
      type: String,
      required: true,
    },
    ratingScore: {
      type: String,
      required: true,
    },
    ratingSelected: {
      type: Function,
      required: true,
    },
  },
  computed: {
    scoreTitle(): string {
      return titles[this.ratingScore];
    },
    scoreDescription(): string {
      return descriptions[this.ratingScore];
    },
  },
};
</script>
